import { generatePath, Link } from "react-router";

import { getImageUrl } from "@/lib/aws-amplify/host-storage";
import { cn } from "@/lib/chillnn/cn";
import { getFragmentData, graphql, type FragmentType } from "@/lib/gql/__generated__";

import { PATHS } from "@/routes/paths";

import { Image } from "@/components/ui/image/image";

export const HotelHotelCardFragment = graphql(/* GraphQL */ `
	fragment HotelHotelCard on Hotel {
		hotelID
		name
		logoImage {
			bucket
			fileName
			key
			mimeType
			region
		}
	}
`);

export const HotelCard = (props: { hotel: FragmentType<typeof HotelHotelCardFragment> }) => {
	const hotel = getFragmentData(HotelHotelCardFragment, props.hotel);
	const { hotelID, name, logoImage } = hotel;

	const imageUrl = logoImage ? getImageUrl(logoImage) : undefined;
	const hotelTopPath = generatePath(PATHS.HOTEL.TOP, { hotelID });

	return (
		<Link
			to={hotelTopPath}
			className="flex gap-5 rounded-lg bg-white p-3 hover:bg-zinc-50 hover:ring-1 hover:ring-zinc-200/40 lg:p-4"
			viewTransition
		>
			<div className="flex items-center gap-x-4">
				<Image
					src={imageUrl}
					className={cn(
						"h-14 w-14 shrink-0 rounded-full border border-zinc-100 object-contain", //
						// 画像がない場合はダミー画像（横長）が表示されるので、object-coverを設定している
						imageUrl ? "object-contain" : "object-cover",
					)}
				/>
				<h5 className="line-clamp-4 break-all text-[15px]">{name}</h5>
			</div>
		</Link>
	);
};
